import {is_weixn} from 'CommonUtils/plus'
import ldPay from 'Components/ldPay/index'

export default {
  orderNo: '',
  orderDetail: {
    orderRangeBeanList: [],
    rangeList:[]
  }, // 机票正常单 详情
  alterOrderDetail: {}, // 机票改签单 详情
  payList: [],
  subjectName:'',
  // ------------获取支付列表入参-----
  // ------支付入参--------
  payMethod: '', // 支付方式
  payRemark: '', // 支付备注
  orderList: [], // 支付订单集合
  paySubject: '', // 支付科目
  reMsg: '',
  //--------------
  orderPriceZong: '', // 该订单的总价   票价  + 服务费
  payTotalPrice: '', // 支付价格总
  newTicketPrice: '', // 新票价
  isShowPay: false, //是否显示支付按钮
  isShowKong:false, //  显示公司未设置
  channelList: {}, //支付渠道
  // 保险
  bxcpList: {},
  bxOrderList: {},
  bxprice:0,
  payPwd:'',//支付密码
  showPwd: 0,//显示支付密码参数控制
  isShowPwd: false,//显示支付密码

  isShowSms: false,
  paySms: '',
  isSendSms: false,
  smsTime: 59,
  smsBtnTxet:'获取验证码',

  manySubjects:false,//是否多科目支付
  manySubjectsArr:[],//多科目支付
  empInfo: {},
  zxzf: '',//在线支付
  zxzf1: '',//在线支付
  qr: {//二维码
    showQr: false,
    qrUrl: '',
    // logo:money,
    time: '',
    text:'',
  },
  posterDataUrl: '',
  dataBase:'',
  compNo: '',
  payHeadStyle: 'linear-gradient(180deg,#4b4b4b 0%,#5a5a5a 18%,@color-background-gray 18%,@color-background-gray 100%),linear-gradient(#45bf98,#45bf98);',
  ssoParam: null,
  params:{
    api:{},
    orderType:'',
    orderId:'',
    isAutoPay:false
  },
  async initAutoPay(api,orderType,orderId){
    this.params.api = api
    this.params.orderType = orderType
    this.params.orderId = orderId
    //获取是否自动支付配置
    let config = await this.getAutoPayConfig()
    //获取订单详情
    await this.getOrder()
    //根据支付配置和订单详情发起自动支付
    return await this.toPayAjax()
  },
  //调用各个产品订单详情
  async getOrder () {
    let orderType = this.params.orderType
    let orderId = this.params.orderId
    let obj = {
      '11001': 'getOrderDetail', //机票正常单
      '11004': 'getOrderDetail', //机票正常单
      '11003': 'getAlertOrderDetail', //机票改签单
      '11006': 'getAlertOrderDetail', //机票改签单
      '11009': 'getTrainOrderDetail',// 火车票正常单
      '11011': 'getTrainAlterDetail',// 火车票改签单
      '11007': 'gethotelOrderDetail',// 酒店正常单
      '11018': 'getCarBookDetail',// 用车
      // '11012': 'getAirServiceDetail',// 机场服务 旧版
      // '11019': 'getAgentOrderDetail',// 代办值机 旧版
      '11023': 'getVisaDetail',// 签证
      '11028': 'getAirServiceDetailNew',// 休息室  2021-01-06
      '11029': 'getAirServiceDetailNew',// 快速安检
      '11030': 'getAirServiceDetailNew',// 优选值机
      '11031': 'getAirServiceDetailNew',// 要客通
    }
    let fun=obj[orderType]||''
    if (fun) {
      await this[fun](orderId)
    } else {
      this.$dialog.alert({
        title: '提示',
        message: '产品类型传入错误！错误值'+ orderType,
      }).then(() => {
        // on close
      })
    }
  },
  //点击支付按钮
  async toPayAjax() {
    let orderList = [{
      'orderId': this.params.orderId,
      'orderNo': this.orderNo,
      'orderType': this.params.orderType,
      'payAmount': this.orderPriceZong,
      'payRemark': '自动支付'
    }]

    // 保险订单
    if (this.bxOrderList.length) {
      this.bxOrderList.forEach(item => {
        orderList.push({
          'orderId': item.id,
          'orderType': '11015',
          'orderNo': item.orderNo,
          'payAmount': item.xsj,
          'payRemark': '自动支付'
        })
      })
    }

    let subjectBeanList = []//多科目集合
    //多科目支付
    if (this.manySubjects) {
      if (this.manySubjectsArr.length == 1) {
        this.$toast('请选择支付科目！')
        return
      }
      this.manySubjectsArr.forEach(item => {
        subjectBeanList.push({
          'payMethod': item.payMethod,
          'paySubject': item.subjectId,
          'payAmount': this.getPayAmount(item),
          'jfAmount': '',//价格说明 用来存积分的兑换金额
        })
        if (item.payMethod != '12105') {//筛选出非公司的支付方式
          this.zxzf = item.zxzf
        }
      })
    } else {
      subjectBeanList = [{
        'payMethod': this.payMethod,
        'paySubject': this.paySubject,
        'payAmount': this.payTotalPrice,
        'jfAmount': '',//价格说明 用来存积分的兑换金额
      }]
    }
    var queryString = {
      'orderList': orderList,
      'payPwd': this.payPwd,
      'payScene': ldPay.methods.getPayScene(this.params.orderType),//获取对应的支付场景
      'subjectBeanList': subjectBeanList,//多科目
      'webHost':process.env.VUE_APP_addressUrl || '',//安卓、ios客户调用支付时，虚拟的访问网站域名。客户端必传
      'zcyh':is_weixn()?'wx':'',//公众号 招行二维码  判断微信还是支付宝
      'buyerId': is_weixn() ? localStorage.getItem('openId') : '',// 微信用户的openId
    }
    let that = this
    // 请求
    let newUrl = 'common/onlinePayNew'
    let autoPayRes = {
      isSuccess:false,
      returnInfo:{}
    }

    if (this.params.isAutoPay){
      await this.params.api[newUrl](queryString).then(resp => {
        console.log('autoPay After{}',resp)
        if (resp.tips === 'success' && resp.errMsg === 'success'){
          autoPayRes.isSuccess = true
        }
        autoPayRes.returnInfo = resp
      })
    }

    return autoPayRes
  },
  //获取是否自动支付配置
  async getAutoPayConfig() {
    let bookModel = 2
    let autoPayCfg = 2
    let payMethodSubject = ''
    //企业预订模式
    await this.params.api['common/queryVipParameter']({
      paramNo:'2004'
    }).then(res => {
      bookModel = res.data.value1
    })
    //因公预订是否自动支付
    await this.params.api['common/queryVipParameter']({
      paramNo:'3001'
    }).then(res => {
      autoPayCfg = res.data.value1
    })
    //因公预订默认自动支付科目
    await this.params.api['common/queryVipParameter']({
      paramNo:'3002'
    }).then(res => {
      let subject = res.data.value1
      if (subject === '1'){
        //预存款
        payMethodSubject = '1210502'
      }else {
        //协议欠款
        payMethodSubject = '1210501'
      }
    })
    if (bookModel === '1' && autoPayCfg === '1'){
      this.params.isAutoPay = true
    }
    console.log('isAutoPay{}',this.params.isAutoPay)
    this.payMethod = '12105'
    this.paySubject = payMethodSubject
    return {
      isAutoPay:this.params.isAutoPay,
      payMethodSubject:payMethodSubject,
      //自动支付暂时只涉及到预存款和协议欠款
      payMethod:'12105'
    }
  },
  //------------------------获取订单详情- START--------------------  //
  //获取机票正常单 详情   ajax
  async getOrderDetail(id) {
    await this.params.api['tkOrder/orderDetail']({
      id: id
    }).then(resp => {
      this.orderDetail = resp.data || {}
      this.orderNo = this.orderDetail.orderNo
      this.orderPriceZong = this.orderDetail.totalPrice
      this.payTotalPrice = this.orderDetail.totalPrice + this.orderDetail.bxPrice
    })
    await this.getBxOrderDetailByOrderId()
  },
  // 获取 改签单支付详情
  getAlertOrderDetail(id) {
    this.params.api['tkOrder/tkChangeOrderDetail']({
      changeOrderId: id
    }).then(resp=> {
      this.alterOrderDetail = resp.data || {}
      this.orderNo = this.alterOrderDetail.changeNo
      this.orderPriceZong = this.alterOrderDetail.changeAmount
      this.payTotalPrice = this.alterOrderDetail.changeAmount
    }).catch(() =>{
      this.isShowPay = false
    })
  },
  //------------------------获取订单详情- START--------------------  //
  // 获取保险单详情
  async getBxOrderDetailByOrderId () {
    var arr = [{
      'orderId': this.params.orderId,
      'orderType': this.params.orderType
    }]
    await this.params.api['bx/getBxOrderListByGlddId']({
      glddId: this.params.orderId
    }).then(res=> {
      var data = res.data || []
      if (data.length > 0) {
        this.bxOrderList=data
        const bxcpList = {}
        // 按 bxcpmc 分组
        for (let i = 0; i < data.length; i++) {
          if (!bxcpList[data[i].bxcpmc]) {
            bxcpList[data[i].bxcpmc] = data[i]
          }
        }
        this.bxcpList = bxcpList

        data.forEach((item)=> {
          arr.push({
            'orderId': item.id,
            'orderType': '11015'
          })
          this.bxprice += item.xsj
        })
        if(isNaN(this.bxprice)){
          this.bxprice = 0
        }
      }
    })
  },
  // 订单支付备注
  getPayRemark (orderType) {
    let obj = {
      // 机票正常单
      '11001':() => `${this.orderDetail.voyageZh}  ${this.orderDetail.orderRangeBeanList[0]['departDate']}`,
      '11004':() => `${this.orderDetail.voyageZh}  ${this.orderDetail.orderRangeBeanList[0]['departDate']}`,
      // 机票改签正常单
      '11003':() => `${this.alterOrderDetail.voyageZh}  ${this.alterOrderDetail.rangeList[0]['nDepartDate']}`,
      '11006':() => `${this.alterOrderDetail.voyageZh}  ${this.alterOrderDetail.rangeList[0]['nDepartDate']}`,
      //火车票正常单
      '11009': () => `${this.orderDetail.fromStationName} - ${this.orderDetail.toStationName}  ${this.orderDetail.fromDate} ${this.orderDetail.trainCode} ${this.orderDetail.seatTypeName}`,
      // 火车票 改签单
      '11011': () => this.orderDetail.newFromStationName + '-' + this.orderDetail.newToStationName + ' ' + this.orderDetail['newFromDate'] + ' ' + this.orderDetail.newTrainCode + ' ' + this.orderDetail.newSeatTypeName,
      // 酒店正常单
      '11007': () => this.orderDetail.cityName + ' ' + this.orderDetail.jdmc + ' ' + this.orderDetail.fxmc + +' ' + this.orderDetail.nights + '晚' + ' ' + '房间数' + this.orderDetail.rooms + ' ' + '入住日期' + this.orderDetail.rzrq + ' ' + this.orderDetail.ldrq,
      // 用车订单
      '11018': () => this.orderDetail.cityName + ' ' + this.orderDetail.startTime +' ' + this.orderDetail.orderTypeName +' ' +this.orderDetail.vehicleTypeName + ' ' +this.orderDetail.useDays+'天 '+ this.orderDetail.rangeType==1?'市郊':'跨城',
      // 机场服务
      '11028': () => this.orderDetail.cityName + ' ' + this.orderDetail.airportName+' ' +this.orderDetail.terminal+' '+this.orderDetail.serviceName+' '+this.orderDetail.serviceType,
      '11029': () => this.orderDetail.cityName + ' ' + this.orderDetail.airportName+' ' +this.orderDetail.terminal+' '+this.orderDetail.serviceName+' '+this.orderDetail.serviceType,
      '11030': () => this.orderDetail.cityName + ' ' + this.orderDetail.airportName+' ' +this.orderDetail.terminal+' '+this.orderDetail.serviceName+' '+this.orderDetail.serviceType,
      '11031': () => this.orderDetail.cityName + ' ' + this.orderDetail.airportName+' ' +this.orderDetail.terminal+' '+this.orderDetail.serviceName+' '+this.orderDetail.serviceType,
      // '11019': () => this.orderDetail.placeName + ' ' + this.orderDetail.terminal +' ' +this.orderDetail.passenger +' '+this.orderDetail.flightNo +' '+ this.orderDetail.totalPrice +' '+this.orderDetail.flightDate,
      '11023': () => this.orderDetail.visaName + ' ' + this.orderDetail.tripDate +' ' +this.orderDetail.psgNameStr +' '+this.orderDetail.totalPrice +' '+this.orderDetail.consularDist
    }
    if (obj[orderType]) {
      return obj[orderType]()
    }
    return ''
  },

}
